module.exports = __webpack_public_path__ + "static/media/connecting_arrow_loader.228367f7.svg";